import React from "react";
import { useMutation } from "react-query";
import { getDetailsForEdit } from "../../../../actions/Utilities/CustomReport";

const useGetDetailsForEdit = () => {
  return useMutation(getDetailsForEdit);
};

export default useGetDetailsForEdit;
